import React from 'react';
import type { LscMember } from '../types';

interface RemoveMemberConfirmModalProps {
  open: boolean;
  member: LscMember | null;
  removing?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const RemoveMemberConfirmModal: React.FC<RemoveMemberConfirmModalProps> = ({
  open,
  member,
  removing = false,
  onClose,
  onConfirm,
}) => {
  if (!open || !member) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      data-testid="remove-member-confirm-modal"
    >
      <div className="w-full max-w-md rounded-lg border border-secondary-700 bg-secondary-900 p-5 space-y-4">
        <div>
          <h2 className="text-lg font-semibold text-white">Remove member from league?</h2>
          <p className="mt-2 text-sm text-secondary-400">
            This will deactivate <span className="text-white">{member.display_name}</span>, hide
            them from active views, and stop future stream matching for this member. Historical
            records remain preserved.
          </p>
        </div>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            className="btn-secondary"
            disabled={removing}
            onClick={onClose}
            data-testid="remove-member-cancel-button"
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn-primary"
            disabled={removing}
            onClick={onConfirm}
            data-testid="remove-member-confirm-button"
          >
            {removing ? 'Removing…' : 'Remove member'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveMemberConfirmModal;
